import { RouteConfig } from 'vue-router'

import IconMenuActive from '../assets/images/icon_menu_exercise_prescription_active@2x.png'
import IconMenuInactive from '../assets/images/icon_menu_exercise_prescription_inactive@2x.png'

const Layout = () => import('../views/Layout.vue')

const ExercisePrescriptionList = () => import('../views/ExercisePrescriptionList.vue')
const ExercisePrescriptionClazzDetail = () => import('../views/ExercisePrescriptionClazzDetail.vue')
const ExercisePrescriptionStudentDetail = () => import('../views/ExercisePrescriptionStudentDetail.vue')
const ExercisePrescriptionTrainingDetail = () => import('../views/ExercisePrescriptionTrainingDetail.vue')
const EPIntroPage = () => import('../views/ExercisePrescriptionNotVipIntro.vue')

export const exercisePrescriptionListRoute: RouteConfig = {
  path: 'exercise-prescription-list',
  name: 'exercise_prescription_list',
  component: ExercisePrescriptionList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '训练计划',
    showMenu: true,
  },
}

export const exercisePrescriptionClazzDetailRoute: RouteConfig = {
  path: 'clazz-detail',
  name: 'exercise_prescription_clazz_detail',
  component: ExercisePrescriptionClazzDetail,
  props: (route) => {
    route.query.startDate = JSON.parse(route.query.startDate as string)
    route.query.endDate = JSON.parse(route.query.endDate as string)
    return { ...route.query, ...route.params }
  },
  meta: {
    title: '训练计划',
    showMenu: false,
  },
}
export const exercisePrescriptionTrainingDetailRoute: RouteConfig = {
  path: 'exercise-prescription-training-detail',
  name: 'exercise_prescription_training_detail',
  component: ExercisePrescriptionTrainingDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '检查训练',
    showMenu: true,
  },
}
export const exercisePrescriptionStudentDetailRoute: RouteConfig = {
  path: 'exercise-prescription-student_detail',
  name: 'exercise_prescription_student_detail',
  component: ExercisePrescriptionStudentDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '训练计划',
  },
}

export const epIntroPage: RouteConfig = {
  path: 'ep-intro',
  name: 'ep_intro',
  component: EPIntroPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '运动处方介绍',
  },
}

export default [
  {
    path: '/exercise-prescription',
    name: 'exercise_prescription',
    component: Layout,
    meta: {
      title: '运动处方',
      icon: IconMenuInactive,
      iconActive: IconMenuActive,
      showMenu: true,
      // isVip: true
    },
    children: [
      exercisePrescriptionTrainingDetailRoute,
      exercisePrescriptionListRoute,
      exercisePrescriptionClazzDetailRoute,
      exercisePrescriptionStudentDetailRoute,
      epIntroPage,
    ],
  },
]
